import { Box, Typography, Chip, capitalize, Paper } from "@mui/material";
import React from "react";
import RenderIf from "../Common/RenderIf/RenderIf";
import useOptions from "./hooks/useOptions";
import useApi from "../../hooks/useApi";
import CommunicationHubApis from "../../services/api/CommunicationHub";
import Shimmer from "sushiweb/Shimmer/Shimmer";
import { pathMappingsReverse } from "./constants";
import { useHistory } from "react-router-dom";

const SequenceDetails = ({ ref_type, ref_id, index }) => {
  const { options } = useOptions();
  const { data, error, isLoading } = useApi({
    queryKey: [ref_id],
    queryFn: () =>
      CommunicationHubApis.getDetail({
        element_type: ref_type,
        element_id: ref_id,
      }),
  });

  const history = useHistory();
  console.log({ isLoading, data, error, index });
  if (isLoading) return <Shimmer height={84} />;

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        justifyContent: "space-between",
        borderRadius: 2,
        px: 2,
        py: 3,
        minHeight: 60,
      }}
    >
      <Typography variant="h6">Section {index + 1}</Typography>
      <Box display={"flex"} gap={2}>
        <Chip
          label={capitalize(pathMappingsReverse[ref_type])}
          variant="outlined"
          sx={{ width: "max-content" }}
        />
        <Chip
          label={data?.is_active ? "Active" : "Inactive"}
          variant="outlined"
          color={data?.is_active ? "success" : "error"}
          sx={{ width: "max-content" }}
        />
      </Box>
      <RenderIf condition={error}>
        <Box display={"flex"} flex gap={2}>
          <Box>
            <Typography variant="body2">Failed to load data</Typography>
          </Box>
        </Box>
      </RenderIf>
      <RenderIf condition={data}>
        <Box display={"flex"} flex gap={2}>
          <img
            src={data?.thumbnail?.landscape}
            alt={data?.name}
            style={{
              height: "100%",
              aspectRatio: "1/1",
              maxWidth: 100,
              borderRadius: 8,
              cursor: "pointer",
            }}
            onClick={() =>
              history.push(
                `/communication-hub/${pathMappingsReverse[ref_type]}/${ref_id}`
              )
            }
          />
          <Box>
            <Typography variant="h6">{data?.name}</Typography>
            <Box
              mb={"12px"}
              sx={{
                "& > p": {
                  fontSize: "14px !important",
                  lineHeight: 1,
                  color: "dimgray",
                  fontStyle: "italic",
                  "& > span": {
                    color: "#1a1a1a",
                  },
                },
              }}
            >
              <Typography variant="body2">
                Last edited on <span>{data?.updated_at}</span>,
              </Typography>
              <Typography variant="body2" lineHeight={1} fontStyle={"italic"}>
                by <span>{data?.updated_by}</span>
              </Typography>
            </Box>
          </Box>
        </Box>
      </RenderIf>
    </Paper>
  );

  return null;
};

export default SequenceDetails;
